// src/components/InputField.js
import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { IconContext } from "react-icons";

const InputField = ({
  label,
  type,
  placeholder,
  value,
  onChange,
  icon,
  error,
  disabled,
  additionalIcon,
  autoComplete,
}) => {
  const [focused, setFocused] = useState(false);

  const wrapperStyle = {
    display: "flex",
    alignItems: "center",
    padding: "0 14px",
    borderRadius: "8px",
    border: `1.5px solid ${error ? "var(--danger)" : focused ? "var(--accent)" : "var(--border-strong)"}`,
    backgroundColor: disabled ? "var(--bg-hover)" : "var(--bg-elevated-2)",
    boxShadow: focused ? "0 0 0 3px var(--accent-soft)" : "none",
    transition: "border-color 0.15s ease, box-shadow 0.15s ease",
  };

  return (
    <Form.Group className="mb-3">
      {label && (
        <Form.Label style={{ color: "var(--text-secondary)", fontSize: "0.85rem" }}>{label}</Form.Label>
      )}
      <div style={wrapperStyle}>
        <IconContext.Provider value={{ size: "1.05em", color: "var(--text-muted)" }}>
          {icon}
        </IconContext.Provider>
        <Form.Control
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          autoComplete={autoComplete}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          className="border-0 shadow-none"
          style={{
            backgroundColor: "transparent",
            color: "var(--text-primary)",
            padding: "10px",
          }}
        />
        {additionalIcon && <div className="d-flex align-items-center">{additionalIcon}</div>}
      </div>
      {error && (
        <div style={{ color: "var(--danger)", fontSize: "0.8rem", marginTop: "4px" }}>{error}</div>
      )}
    </Form.Group>
  );
};

export default InputField;
